import React, {Fragment} from 'react';
import {
	AlertActions,
	AlertModal,
	MainHeader,
	PageWrapperLayout,
	Snackbar,
	StyledGrid,
} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages';
import {Button, Divider, Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {Loading} from './components/Loading';
import {ContextMenu} from './components/ContextMenu';
import {Card} from './components/Card';
import {useListFavoritePlaces} from './hooks/useListFavoritePlaces';
import {EmptyState} from './components/EmptyState';

const {title, favoritePlaces, addNewAddress, alertRemoveFavoritePlace} =
	translations['pt-br'].privateFlow.bookingFlow.location;

export function HealthGuideFavoritePlacesList() {
	const {isMobile, isTablet, isLaptop} = useMediaQueries();
	const {
		navToServiceNetworkHealthGuide,
		recentlyVisitedItem,
		listItems,
		handleContextMenuOpen,
		handleContextMenuClose,
		handleCardClick,
		handleEdit,
		handleDelete,
		handleAddNewAddress,
		handleCloseRemoveFavoritePlaceAlert,
		handleDeleteConfirmed,
		handleCloseDeleteError,
		openRemoveFavoritePlaceAlert,
		openDeleteError,
		anchorContextMenuEl,
		isMenuOpen,
		isLoading,
		isDeletingFavoritePlace,
		loadingCardClickId,
	} = useListFavoritePlaces();

	if (isLoading) {
		return (
			<PageWrapperLayout title={favoritePlaces}>
				<MainHeader
					title={favoritePlaces}
					handleBack={navToServiceNetworkHealthGuide}
					hideProfileMenu
				/>
				<Loading isMobile={isMobile} />
			</PageWrapperLayout>
		);
	}

	if (!recentlyVisitedItem && listItems.length === 0) {
		return (
			<PageWrapperLayout title={favoritePlaces}>
				<MainHeader
					title={favoritePlaces}
					handleBack={navToServiceNetworkHealthGuide}
					hideProfileMenu
				/>
				<EmptyState handleAddNewAddress={handleAddNewAddress} />
			</PageWrapperLayout>
		);
	}

	return (
		<PageWrapperLayout title={favoritePlaces}>
			<MainHeader
				title={favoritePlaces}
				handleBack={navToServiceNetworkHealthGuide}
				hideProfileMenu
			/>
			<Stack
				alignItems="center"
				pb={isMobile || isTablet ? 10 : 0}
				my={4}
				mx={isLaptop ? 4 : 'auto'}>
				<Stack width={isLaptop ? '100%' : 618} gap={2}>
					{recentlyVisitedItem ? (
						<Fragment>
							{listItems.length === 0 && (
								<Typography variant="subtitle2" color="text.secondary">
									{title}
								</Typography>
							)}
							<Card
								item={recentlyVisitedItem}
								handleContextMenuOpen={handleContextMenuOpen}
								handleCardClick={handleCardClick}
								recentlyVisited
								isLoading={loadingCardClickId === recentlyVisitedItem.id}
							/>
						</Fragment>
					) : null}

					{listItems.length > 0 ? (
						<Fragment>
							<Typography variant="subtitle2" color="text.secondary">
								{title}
							</Typography>
							<StyledGrid.Root>
								{listItems.map((item, index) => (
									<StyledGrid.Item key={index} sm={12} md={6} lg={6}>
										<Card
											item={item}
											handleContextMenuOpen={handleContextMenuOpen}
											handleCardClick={handleCardClick}
											isLoading={loadingCardClickId === item.id}
										/>
									</StyledGrid.Item>
								))}
							</StyledGrid.Root>
						</Fragment>
					) : null}

					<Divider />
					<Stack alignItems={'end'}>
						<Button
							variant="outlined"
							size="large"
							fullWidth={isLaptop}
							onClick={handleAddNewAddress}>
							{addNewAddress}
						</Button>
					</Stack>
				</Stack>
			</Stack>
			<ContextMenu
				anchorContextMenuEl={anchorContextMenuEl}
				isMenuOpen={isMenuOpen}
				handleContextMenuClose={handleContextMenuClose}
				handleEdit={handleEdit}
				handleDelete={handleDelete}
			/>
			<AlertModal
				headerTitle={alertRemoveFavoritePlace.headerTitle}
				title={alertRemoveFavoritePlace.title}
				variant="info"
				description={alertRemoveFavoritePlace.description}
				open={openRemoveFavoritePlaceAlert}
				onClose={handleCloseRemoveFavoritePlaceAlert}
				footerContent={
					<AlertActions
						primaryText={alertRemoveFavoritePlace.primary}
						secondaryText={alertRemoveFavoritePlace.secondary}
						primaryAction={handleDeleteConfirmed}
						secondaryAction={handleCloseRemoveFavoritePlaceAlert}
						flexDirection="column-reverse"
						isLoading={isDeletingFavoritePlace}
						isDisabled={isDeletingFavoritePlace}
					/>
				}
			/>
			<Snackbar
				onClose={handleCloseDeleteError}
				open={openDeleteError}
				message={alertRemoveFavoritePlace.error}
			/>
		</PageWrapperLayout>
	);
}
